import { Box } from '@mui/material'
import React from 'react'
import { PropTypes } from 'prop-types'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@emotion/react'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import config from '../../config/config'
import { setDrawerOpen } from '../../slices/mainTool'
import { themeConfig } from '../../config/theme.config'
import SwipeableProjectInputs from './SwipeableProjectInputs'
import CustomButton from '../CustomButton'
import { setAllModalTiers } from '../../slices/generalInputs/modalTiers'
import {
  setManualStreetMode,
  setShowResetTiersModal
} from '../../slices/appSlice'

export const SectionTitle = ({
  children,
  color = config.themeConfig.semcogBlue1,
  fontWeight = 'bold',
  fontSize = config.themeConfig.headerFontSize,
  textAlign = 'left',
  marginTop = '0 em'
}) => {
  return (
    <Typography
      variant="h2"
      noWrap={true}
      sx={{
        fontSize,
        fontWeight,
        color,
        textAlign,
        marginTop
      }}
    >
      {children}
    </Typography>
  )
}

export const SubSectionTitle = ({
  children,
  alignSelf = 'left',
  color = config.themeConfig.semcogBlack,
  noWrap = false,
  fontWeight = 600,
  fontSize,
  marginBottom = '0em',
  textAlign
}) => {
  return (
    <Typography
      variant="body1"
      noWrap={noWrap}
      sx={{
        fontSize: fontSize || config.themeConfig.questionFontSize,
        color,
        alignSelf,
        fontWeight,
        marginBottom,
        textAlign
      }}
    >
      {children}
    </Typography>
  )
}
export const Wrapper = ({ children, p = '1.5em' }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        p,
        overflow: 'hidden',
        height: '100%'
      }}
    >
      {children}
    </Box>
  )
}

export default function ProjectInputs() {
  const dispatch = useDispatch()
  const { projectInputStep } = useSelector((state) => state.mainTool)
  const { defaultModalTiers } = useSelector((state) => state.appSlice)
  const { modalTiers } = useSelector((state) => state)

  function resetModalTierInputs() {
    dispatch(setShowResetTiersModal(true))
  }
  return (
    <Wrapper>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', p: '0em 2em' }}
      >
        <Box>
          <SectionTitle>Set Up Your Project</SectionTitle>
          <SubSectionTitle
            color={themeConfig.semcogBlue1}
            fontWeight={400}
            fontSize={16}
          >
            Enter or confirm the details for your project.
          </SubSectionTitle>
        </Box>
        <Box sx={{ display: 'flex', alignContent: 'center' }}>
          {projectInputStep === 2 && (
            <CustomButton
              btnLabel="Reset Inputs"
              handleNext={() => {
                resetModalTierInputs()
              }}
              marginTop={0}
              disabled={
                // If the modalTiers are the same as the defaultModalTiers, then the reset button should be disabled
                JSON.stringify(modalTiers) === JSON.stringify(defaultModalTiers)
              }
              showDisabledTooltip={true}
              helpText="Nothing to reset"
              backgroundColor={config.themeConfig.semcogBlue1}
            />
          )}
          <IconButton
            sx={{
              alignSelf: 'center',
              '& .MuiSvgIcon-root': { fontSize: '2rem' }
            }}
            color="inherit"
            onClick={() => {
              dispatch(setDrawerOpen(false))
              // when drawer close , set manual street mode to false
              dispatch(setManualStreetMode(false))
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <hr style={{ border: '0.1px solid lightGrey' }} />
      <SwipeableProjectInputs />
    </Wrapper>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.string.isRequired,
  color: PropTypes.string,
  fontWeight: PropTypes.number,
  fontSize: PropTypes.number,
  textAlign: PropTypes.string,
  marginTop: PropTypes.string
}
SubSectionTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.node
  ]),
  alignSelf: PropTypes.string,
  color: PropTypes.string,
  noWrap: PropTypes.bool,
  fontWeight: PropTypes.number,
  fontSize: PropTypes.number,
  marginBottom: PropTypes.string,
  textAlign: PropTypes.string
}
Wrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  p: PropTypes.string
}
